import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";

const links = [
  { to: "/privacy", key: "footerPrivacy" },
  { to: "/terms", key: "footerTerms" },
  { to: "/imprint", key: "footerImprint" },
  { to: "/cookies", key: "footerCookies" },
  { to: "/withdrawal", key: "footerWithdrawal" },
];

export function Footer({ className = "" }) {
  const { t } = useApp();
  return (
    <footer data-testid="app-footer" className={`mt-8 pt-5 border-t-2 border-gray-200 ${className}`}>
      <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs font-body text-gray-500">
        {links.map((l, i) => (
          <React.Fragment key={l.to}>
            {i > 0 && <span className="text-gray-300">·</span>}
            <Link data-testid={`footer-link${l.to}`} to={l.to} className="underline hover:text-gray-800">{t(l.key)}</Link>
          </React.Fragment>
        ))}
      </div>
      <p className="mt-2 text-center text-[11px] font-body text-gray-400">© {new Date().getFullYear()} SafeBuddy</p>
    </footer>
  );
}
